import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 28,
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    fontSize: 14,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
  },
  infoBox: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: 8,
    padding: theme.spacing(2, 2.5),
    marginBottom: theme.spacing(3),
    textAlign: 'center',
  },
  infoLabel: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
  },
  contactText: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.primary.main,
    wordBreak: 'break-all',
  },
  digitsRow: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  digitInput: {
    width: 48,
    '& input': {
      textAlign: 'center',
      fontSize: 20,
      fontWeight: 600,
      padding: theme.spacing(1.5, 0),
    },
  },
  resendRow: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
    fontSize: 13,
    color: theme.palette.text.secondary,
  },
  resendButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: 13,
    textDecoration: 'underline',
    '&:hover': { opacity: 0.8 },
  },
  submitButton: {
    marginTop: theme.spacing(3),
    height: 48,
    fontWeight: 600,
    letterSpacing: 1,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
  },
}))

export default useStyles
